// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2487":"53fbcee5","4370":"8a186c22","5619":"3f9c4fb7","6673":"3f9c4fb7"}[chunkId] + ".chunk.css";
};